import React, { createContext, useContext, useState, useEffect } from "react";
import { darkTheme, lightTheme, getStyles } from "../styles/theme";

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('deluxe-theme');
    return saved ? saved === 'dark' : true;
  });

  const theme = isDark ? darkTheme : lightTheme;
  const styles = getStyles(theme);

  function toggleTheme() {
    setIsDark(prev => {
      const next = !prev;
      localStorage.setItem('deluxe-theme', next ? 'dark' : 'light');
      return next;
    });
  }

  return (
    <ThemeContext.Provider value={{ theme, styles, isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}